import React from 'react';
import { X } from 'lucide-react';

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  const styles = {
    error: {
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '24px'
    },
    errorContent: {
      display: 'flex',
      alignItems: 'center',
      color: '#b91c1c'
    }
  };

  return (
    <div style={styles.error}>
      <div style={styles.errorContent}>
        <X size={20} style={{ marginRight: '12px' }} />
        <p className="p-style">{message}</p>
      </div>
    </div>
  );
};

export default ErrorMessage;